export function AdminTypologiesView () {
    return (
        <div>
            Admin typologies
        </div>
    );
}
